export const players_heads = [
  ['Num.', 'PLAYER', 'POS', 'GP', 'G', 'A', 'PTS', 'PIM', 'PPG', 'PPA', 'SHG', 'SHA'],
  ['jersey', 'fullname', 'position', 'gamesplayed', 'goals', 'assists', 'points', 'penaltyminutes', 'powerplaygoals', 'powerplayassists', 'shorthandedgoals', 'shorthandedassists']
];

export const goalies_heads = [
  ['Num.', 'GOALIE', 'GP', 'MINS', 'W', 'L', 'SO', 'GA', '2ptGA', 'SV', 'SV%'],
  ['jersey', 'fullname', 'gamesplayed', 'min', 'wins', 'losses', 'shutouts', 'goalsagainst', 'twopointgoalsagainst', 'saves', 'savepercentage']
];

export const scoring_heads = [
  ['GOAL', 'PD', 'TIME', 'SCORER', 'ASSISTS'],
  ['number', 'period', 'time', 'fullname', 'assist1']
];

export const penalties_heads = [
  ['PD', 'TIME', 'PLAYER', 'PENALTY', 'MINS'],
  ['period', 'time', 'fullname', 'infraction', 'minutes']
];

export const rosters_head = [
  ['PLAYER', 'G', 'A', 'Pts.', 'PPG', 'SHG', 'Penalty'],
  ['fullname', 'goals', 'assists', 'points', 'powerplaygoals', 'shorthandedgoals', 'penaltyminutes']
];

export const rosters_goalies = [
  ['DEC', 'MIN', 'GA', '2ptGA', 'SOG', 'SAVES'],
  ['decision', 'min', 'goalsagainst', 'twopointgoalsagainst', 'shotsagainst', 'saves']
]

export const game_summary = [
  ['GOALS', 'SHOTS', 'SAVES', 'FACEOFF %', 'MAN UP %'],
  ['goals', 'shotsoffgoal', 'saves', 'faceoffs', 'powerplayadvantages']
];

export const game_matchup = [
  ['GF', 'GP', 'PIM', 'GA', 'DIV RANK', 'WPCT'],
  ['goalsfor', 'gb', 'penaltyminutes', 'goalsagainst', 'rank', 'winningpercentage']
];

export const team_stats = [
  ['GF', 'GP', 'PIM'],
  ['goalsfor', 'gb', 'penaltyminutes'], 
  ['GA', 'DIV RANK', 'WPCT'],
  ['goalsagainst', 'rank', 'winningpercentage']
]

export const player_stats_info_bis = [
  ['YEAR', 'TEAM', 'GP', 'G', 'A', 'PTS', 'PIM', 'PPG', 'PPA', 'SHG', 'SHA', 'GWG'],
  ['year', 'teamName', 'gp', 'g', 'a', 'pts', 'pim', 'ppg', 'ppa', 'shg', 'sha', 'gwg']
];

export const player_stats_info = [
  ['YEAR', 'TEAM', 'GP', 'MINS', 'W', 'L', 'SO', 'GA', '2ptGA', 'SV', 'SV%'],
  ['year', 'team', 'gamesplayed', 'min', 'wins', 'losses', 'so', 'ga', 'gaa', 'sv', 'svpct']
]

export const player_info = [
  ['POS', 'HEIGHT', 'WEIGHT', 'BIRTHDAY', 'HOMETOWN', 'SCHOOL'],
  ['position', 'height', 'weight', 'dob', 'birthPlace', 'school']
];

export const fighter_info = [
  [ 'HEIGHT', 'WEIGHT', 'BIRTHDAY', 'HOMETOWN'],
  [ 'height', 'weight', 'dob', 'birthPlace']
];

export const roster_stats_heads = [
  ['Num.', 'NAME', 'POS', 'HEIGHT', 'WEIGHT', 'BIRTHDAY', 'HOMETOWN'],
  ['jersey', 'fullname', 'position', 'height', 'weight', 'birthdate', 'hometown']
]

export const fight_heads = ['Round', 'Time', 'Fighter', 'AS', 'AS%', 'LS', 'LS%', 'GS', 'GS%'];

export const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

export const dates = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];